import { createAction } from '@lingoda/core';
import type { Date } from '@lingoda/dates';

export default createAction<Date>('time/SET_TIME');
